import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import {
  KanbanCardActions,
  ButtonGroup,
  Actions,
  ActionsButton,
  ListActionItem,
} from "./styles/actions-cog-styles";

const ActionsCog = ({ actions, isDragging }) => {
  const actionsList = actions.map(
    (action) =>
      action && (
        <ListActionItem
          key={action.id}
          onClick={action.clickAction}
          data-test-id={action.name}
        >
          {action.name}
        </ListActionItem>
      )
  );

  return (
    <KanbanCardActions>
      <ButtonGroup className="button-group">
        <ActionsButton
          data-toggle="dropdown"
          data-test-id="actions-dropdown"
          isDragging={isDragging}
        >
          <FontAwesomeIcon icon={faCog} />
        </ActionsButton>
        <Actions className="dropdown-menu" role="menu">
          {actionsList}
        </Actions>
      </ButtonGroup>
    </KanbanCardActions>
  );
};

ActionsCog.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.number,
        clickAction: PropTypes.func,
        name: PropTypes.string,
      }),
      PropTypes.bool,
    ])
  ).isRequired,
  isDragging: PropTypes.bool,
};

ActionsCog.defaultProps = {
  isDragging: PropTypes.isNull,
};

export default ActionsCog;
